"use strict";
/* eslint-disable no-plusplus */
/* eslint-disable finley/variable-length */
/* eslint-disable no-restricted-syntax */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuzzyMatch = exports.canEdit = void 0;
// generates a PartialString from a string
const strToPartialString = (str) => ({
    characters: [...str],
    startIndex: 0,
    endIndex: str.length - 1,
});
const getLength = (str) => str.endIndex - str.startIndex + 1;
const areEqual = (a, b) => {
    const aLength = getLength(a);
    if (aLength !== getLength(b)) {
        return false;
    }
    for (let i = 0; i < aLength; i++) {
        if (a.characters[a.startIndex + i] !== b.characters[b.startIndex + i]) {
            return false;
        }
    }
    return true;
};
// returns true if all characters in str are in swapChars
const hasAllSwapChars = ({ str, swapChars, }) => {
    if (swapChars.size === 0) {
        return true; // if swapChars are empty, then all characters are considered to be in swapChars
    }
    for (let i = str.startIndex; i <= str.endIndex; i++) {
        if (!swapChars.has(str.characters[i])) {
            return false;
        }
    }
    return true;
};
// returns true if strA can be converted to strB using maxEdits, and only changing swapChars.
const canEdit = ({ strA, strB, maxEdits, swapChars, }) => {
    // if strA and strB are equal, we don't need any edits
    if (areEqual(strA, strB)) {
        return true;
    }
    // if we have exhausted all edits, return false
    if (maxEdits === 0) {
        return false;
    }
    const aLength = getLength(strA);
    const bLength = getLength(strB);
    if (Math.abs(aLength - bLength) > maxEdits) {
        return false;
    }
    if (aLength === 0) {
        return hasAllSwapChars({ str: strB, swapChars });
    }
    if (bLength === 0) {
        return hasAllSwapChars({ str: strA, swapChars });
    }
    // at this point we know that both strings are non-zero length.
    const strAFirstChar = strA.characters[strA.startIndex];
    const strBFirstChar = strB.characters[strB.startIndex];
    if (strAFirstChar === strBFirstChar) {
        // if first characters are same, check if rest of the string is a match
        // we did not use any edit here, so we don't decrement maxEdits
        return (0, exports.canEdit)({
            strA: { ...strA, startIndex: strA.startIndex + 1 },
            strB: { ...strB, startIndex: strB.startIndex + 1 },
            maxEdits,
            swapChars,
        });
    }
    const canSwapChar = (char) => swapChars.size === 0 || swapChars.has(char);
    // if 1st character is different we can try three things.
    // 1. insert strBFirstChar in strA ( if strBFirstChar swapChars)
    // 2. delete strAFirstChar from strA ( if strAFirstChar is in swapChars)
    // 3. replace a strAFirstChar in strA with strBFirstChar ( if both are in swapChars)
    // 1. insert strBFirstChar in strA ( if strBFirstChar swapChars)
    if (canSwapChar(strBFirstChar) &&
        (0, exports.canEdit)({
            strA,
            strB: { ...strB, startIndex: strB.startIndex + 1 },
            maxEdits: maxEdits - 1,
            swapChars,
        })) {
        return true;
    }
    // 2. delete strAFirstChar from strA ( if strAFirstChar is in swapChars)
    if (canSwapChar(strAFirstChar) &&
        (0, exports.canEdit)({
            strA: { ...strA, startIndex: strA.startIndex + 1 },
            strB,
            maxEdits: maxEdits - 1,
            swapChars,
        })) {
        return true;
    }
    // 3. replace a strAFirstChar in strA with strBFirstChar ( if both are in swapChars)
    if (canSwapChar(strAFirstChar) &&
        canSwapChar(strBFirstChar) &&
        (0, exports.canEdit)({
            strA: { ...strA, startIndex: strA.startIndex + 1 },
            strB: { ...strB, startIndex: strB.startIndex + 1 },
            maxEdits: maxEdits - 1,
            swapChars,
        })) {
        return true;
    }
    return false;
};
exports.canEdit = canEdit;
/**
 *
 * returns if strA is a fuzzy match of strB
 * strA is a fuzzy match of strB if strA can be converted to strB by at most maxEdits edits
 * edit can be one of
 * 1. insert a character
 * 2. delete a character
 * 3. replace a character
 * swapChars is a string of characters that can be edited
 */
const isFuzzyMatch = ({ strA, strB, maxEdits, swapChars, }) => {
    // its much easier to operate on arrays than strings
    // convert strings to character arrays (there is not `char` type in JS, so we use string of length 1)
    return (0, exports.canEdit)({
        strA: strToPartialString(strA),
        strB: strToPartialString(strB),
        maxEdits,
        swapChars: new Set([...swapChars]),
    });
};
exports.isFuzzyMatch = isFuzzyMatch;
//# sourceMappingURL=isFuzzyMatch.js.map